// removed by extract-text-webpack-plugin
module.exports = {"fileSize":"File__fileSize___2uQCy","link":"File__link___CmdPU","options":"File__options___gIqoS","iconDownload":"File__iconDownload___2qtAL"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/File/components/File.scss
// module id = 1210
// module chunks = 1